<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="475">
      <!-- <template #activator="{ attrs, on }">
        <v-btn
          v-bind="attrs"
          color="primary"
          depressed
          outlined
          v-on="on">
          <v-icon left>
            mdi-plus-circle
          </v-icon>
          เพิ่ม Event
        </v-btn>
      </template> -->
      <v-card color="pa-2">
        <v-card-title>
          <div class="text-h2-headline primary--text">
            Messaging Ad Event
          </div>
          <v-spacer />
          <v-btn
            icon
            small
            @click="setDialog(false)">
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <AdEventForm />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            rounded
            @click="setDialog(false)">
            ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            depressed
            rounded
            @click="submit()">
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AdEventForm from './AdEventForm.vue'

export default {
  components: { AdEventForm },
  props: {
    small: Boolean
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    submit () {
      this.setDialog(false)
    },
    setDialog (dialog = false) {
      this.dialog = dialog
    }
  }
}
</script>

<style lang="scss">

</style>
